import { string } from './type-checkers.js';
import { wrapCompositeType } from './util.js';
const base = () => string;
const wrappedComponentName = wrapCompositeType(base, { type: 'componentName' }, true);
function componentName(componentType) {
    return wrappedComponentName(componentType);
}
export { componentName, };
//# sourceMappingURL=component-name.js.map